export enum SessionVariable {
    ACESS_TOKEN = 'access_token',
    REFRESHT_TOKEN_KEY = 'refresh_token',
    ORDER_ID = 'orderId',
    REDIRECTION_URL = 'redirectUrl',
    MERCHANT_REDIRECT_URL = 'merchantRedirectUrl',
    PAYMENT_REFERENCE = 'paymentReference',
    FAIL_ERROR_MSG = "orderFailMessage",
    AUTO_PAY = "autoPay",
    PAYMENT_PLAN_ID = "paymentPlanId",
    NATIONAL_ID = "nationalId",
    REG_OTP = "reg_otp",
    REQ_ID = "reqID",
    REGIS_NUMBER = "regis_number",
    OTP_REF = "otpRef",
    MOBILE_NUMBER = "mobileNumber",
    COUNTRY_CODE = "countryCode",
    LANGUAGE = "lang",
    AUTH_PROFILE = "authProfile",
    PAID_BY_APPLE = "paidByApple",
    WEBVIEWIOS = 'webviewios',
    USERID = 'id'
}
